var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/personal-stylist/sizes.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <h2 class=\"c-personal-stylist__h2\" data-qa-sizes-heading>\n            ";
output += runtime.suppressValue((lineno = 5, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_sizes"])), env.opts.autoescape);
output += "\n        </h2>\n\n        <p class=\"c-personal-stylist__details\" data-qa-sizes-description>\n            ";
output += runtime.suppressValue((lineno = 9, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_sizes-copy"])), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8 u-no-gutters\">\n\n        <div class=\"o-column o-extra-small--12 o-medium--6\">\n\n            <div class=\"c-form__field\">\n\n                <label for=\"size_tops\" class=\"c-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 25, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_tops-label"])), env.opts.autoescape);
output += "\n                </label>\n\n                <input type=\"text\" name=\"size_tops\" class=\"c-form__text\" data-qa-tops-size/>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-column o-extra-small--12 o-medium--6\">\n\n            <div class=\"c-form__field\">\n\n                <label for=\"bottoms\" class=\"c-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 39, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_bottoms-label"])), env.opts.autoescape);
output += "\n                </label>\n\n                <input type=\"text\" name=\"size_bottoms\" class=\"c-form__text\" data-qa-bottoms-size/>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8 u-no-gutters\">\n\n        <div class=\"o-column o-extra-small--12 o-medium--6\">\n\n            <div class=\"c-form__field\">\n\n                <label for=\"dresses\" class=\"c-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 61, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_dresses-label"])), env.opts.autoescape);
output += "\n                </label>\n\n                <input type=\"text\" name=\"size_dresses\" class=\"c-form__text\" data-qa-dresses-size/>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-column o-extra-small--12 o-medium--6\">\n\n            <div class=\"c-form__field\">\n\n                <label for=\"shoes\" class=\"c-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 75, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_shoes-label"])), env.opts.autoescape);
output += "\n                </label>\n\n                <input type=\"text\" name=\"size_shoes\" class=\"c-form__text\" data-qa-shoes-size/>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/personal-stylist/sizes.j2"] , dependencies)